import React from "react";
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import SaitButton from "../atomic/SaitButton";
import TableRowsIcon from "@mui/icons-material/TableRows";
import i18next from "../localization/i18n";

export default function GridToolbarDensitySelector(props) {
	const { settings, onSettingsChange } = props;

	const [settingsMenuOpen, setSettingsMenuOpen] = React.useState(false);
	const settingsMenuTriggerRef = React.useRef(null);

	const DENSITY_OPTIONS = [
		{ label: i18next.t("compact_density"), value: "compact" },
		{ label: i18next.t("standard_density"), value: "standard" },
		{ label: i18next.t("comfortable_density"), value: "comfortable" },
	];

	return (
		<>
			{props.toolbarIcons ? (
				<IconButton
					ref={settingsMenuTriggerRef}
					id="settings-menu-trigger"
					aria-controls="settings-menu"
					aria-haspopup="true"
					aria-expanded={settingsMenuOpen ? "true" : undefined}
					onClick={() => setSettingsMenuOpen(true)}
				>
					<TableRowsIcon color="primary" />
				</IconButton>
			) : (
				<SaitButton
					ref={settingsMenuTriggerRef}
					id="settings-menu-trigger"
					aria-controls="settings-menu"
					aria-haspopup="true"
					aria-expanded={settingsMenuOpen ? "true" : undefined}
					text={i18next.t("density")}
					onClick={() => setSettingsMenuOpen(true)}
					startIcon={<TableRowsIcon />}
					variant="text"
				/>
			)}

			<Menu
				id="settings-menu"
				anchorEl={settingsMenuTriggerRef.current}
				open={settingsMenuOpen}
				onClose={() => setSettingsMenuOpen(false)}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				slotProps={{
					list: {
						"aria-labelledby": "settings-menu-trigger",
					},
				}}
			>
				{DENSITY_OPTIONS.map((option) => (
					<MenuItem
						key={option.value}
						onClick={() =>
							onSettingsChange((currentSettings) => ({
								...currentSettings,
								density: option.value,
							}))
						}
					>
						<ListItemIcon>{settings.density === option.value && <CheckIcon fontSize="small" />}</ListItemIcon>
						<ListItemText>{option.label}</ListItemText>
					</MenuItem>
				))}
				<Divider />
				<MenuItem
					onClick={() =>
						onSettingsChange((currentSettings) => ({
							...currentSettings,
							showColumnBorders: !currentSettings.showColumnBorders,
						}))
					}
				>
					<ListItemIcon>{settings.showColumnBorders && <CheckIcon fontSize="small" />}</ListItemIcon>
					<ListItemText>{i18next.t("show_column_borders")}</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() =>
						onSettingsChange((currentSettings) => ({
							...currentSettings,
							showCellBorders: !currentSettings.showCellBorders,
						}))
					}
				>
					<ListItemIcon>{settings.showCellBorders && <CheckIcon fontSize="small" />}</ListItemIcon>
					<ListItemText>{i18next.t("show_cell_borders")}</ListItemText>
				</MenuItem>
			</Menu>
		</>
	);
}
